import { ContentfulImageProps } from './optimizeContentfulImage.types'

const optimizeContentfulImage = (
	url: string,
	contentfulImageProps: ContentfulImageProps
): string | null => {
	if (!url || !contentfulImageProps) return null

	try {
		// Parse the URL and preserve existing params
		const urlObj = new URL(url)
		const newParams = new URLSearchParams(urlObj.search)

		const {
			height,
			width,
			quality = '75',
			format = 'webp',
			fit = 'fill',
			focus,
			radius,
			background,
			progressive,
			resizeStrategy,
		} = contentfulImageProps

		// Add optional parameters only if they are defined
		height && newParams.set('h', (height * 2).toString())
		width && newParams.set('w', (width * 2).toString())
		quality && newParams.set('q', quality.toString())
		format && newParams.set('fm', format)
		fit && newParams.set('fit', fit)
		focus && newParams.set('f', focus)
		radius && newParams.set('r', radius.toString())
		background && newParams.set('bg', background)
		progressive && newParams.set('fl', 'progressive')
		resizeStrategy && newParams.set('rs', resizeStrategy)

		return `${urlObj.origin}${urlObj.pathname}?${newParams.toString()}`
	} catch (error) {
		return url
	}
}

export default optimizeContentfulImage
